import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unpaid-invoice',
  templateUrl: './unpaid-invoice.component.html',
  styleUrls: ['./unpaid-invoice.component.css']
})
export class UnpaidInvoiceComponent implements OnInit {
 
  private dp = [];
  displayedColumns = ['invoice_no', 'invoice_date', 'payment_date', 'final_total'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'title': 'الفواتير المستحقة' };

  type = '';
  no = '';
  name = '';
  title = 'الفواتير المستحقة';
  back_link = '';

  Due_Invoice; Customer_Due_Invoice; Supplier_Due_Invoice; Name; Number;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private route: ActivatedRoute,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Due_Invoice').subscribe((res: string) => {
      this.Due_Invoice = res;
    });
    this.title = this.Due_Invoice;
    this.model['title'] = this.Due_Invoice;

    translate.get('Customer_Due_Invoice').subscribe((res: string) => {
      this.Customer_Due_Invoice = res;
    });

    translate.get('Supplier_Due_Invoice').subscribe((res: string) => {
      this.Supplier_Due_Invoice = res;
    });

    translate.get('Name').subscribe((res: string) => {
      this.Name = res;
    });

    translate.get('Number').subscribe((res: string) => {
      this.Number = res;
    });

  }



  ngOnInit() {
    this.model['from_date'] = undefined;

    this.route.params.subscribe(params => {
      this.type = params['type'];
      this.no = params['no'];

      ////////////////////////// CUSTOMER //////////////////////////

      if (this.type == 'customer') {
        this.title = this.Customer_Due_Invoice;
        this.back_link = '../../../customer_list';
        let customer;
        let query = "SELECT `customer_name` FROM `customer` WHERE `customer_no` = '" + this.no + "' AND `status` = '1'";
        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            customer = data.data['list'];
            this.name = customer['0']['customer_name'];
          });
        this.search();
      }

      ////////////////////////// SUPPLIER //////////////////////////

      else if (this.type == 'supplier') {
        this.title = this.Supplier_Due_Invoice;
        this.back_link = '../../../supplier_list';
        let supplier;
        let query = "SELECT `supplier_name` FROM `supplier` WHERE `supplier_no` = '" + this.no + "' AND `status` = '1'";
        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            supplier = data.data['list'];
            this.name = supplier['0']['supplier_name'];
          });
        this.search();
      }
      this.model['title'] = this.title;
    });
  }

  search() {
    let condition = "";

    if (this.model['from_date'] != undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate();
      condition += " AND `payment_date` >= '" + from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate();
      condition += " AND `payment_date` <= '" + to_date + "'";
    }

    ////////////////////////// CUSTOMER //////////////////////////

    if (this.type == 'customer') {
      let today = new Date();
      let today_date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      let query = "SELECT *, (`total` + `tax` - `discount`) AS 'final_total' FROM `invoice` WHERE `customer_no` = '" +
        this.no + "' AND `status` = '1' AND `payment_method` = 'credit' AND `is_paid` = '0'" + condition;
      //console.log(query);
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }

    ////////////////////////// SUPPLIER //////////////////////////

    else if (this.type == 'supplier') {
      let today = new Date();
      let today_date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      let query = "SELECT *, (`amount` + `tax` - `discount`) AS 'final_total' FROM `supplier_invoice` WHERE `supplier_no` = '" +
        this.no + "' AND `status` = '1' AND `payment_method` = 'credit' AND `is_paid` = '0'" + condition;
      //console.log(query);
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];
          this.dp.forEach(element => {
            element.invoice_date = (element.invoice_date).substring(0, 10);
          });
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.title + ' </td></tr>';
    html_data += '<tr><td width="50%"> ' + this.Name + ': ' + this.name + '</td><td width="50%"> ' + this.Number + ': ' + this.no + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}


